import type { ProductCard } from "@/lib/centra/formatters/formatProductCards/formatProductCard";
import { ProductListingPageStoryblok } from "@/types/storyblok-blok-types";

const formatProductsForPlp = (
  products: ProductCard[] | undefined,
  bloks: ProductListingPageStoryblok["bloks"],
) => {
  // divide into arrays of 8
  const formattedProducts: {
    products: ProductCard[];
    editorial?: Required<ProductListingPageStoryblok>["bloks"][number][];
  }[] = [];
  if (!products) return formattedProducts;
  for (let i = 0; i < products.length; i += 8) {
    formattedProducts.push({
      products: products.slice(i, i + 8),
      editorial: bloks?.slice(i, i + 1000),
    });
  }
  return formattedProducts;
};
export default formatProductsForPlp;
